import { render, staticRenderFns } from "./DrawerCreateGift.vue?vue&type=template&id=f9f85d5c&scoped=true&"
import script from "./DrawerCreateGift.vue?vue&type=script&lang=js&"
export * from "./DrawerCreateGift.vue?vue&type=script&lang=js&"
import style0 from "./DrawerCreateGift.vue?vue&type=style&index=0&id=f9f85d5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f85d5c",
  null
  
)

export default component.exports